// @ts-strict-ignore
import {FormControl, ValidationErrors} from "@angular/forms";
import {Assessment} from "@models";

export const AssessmentValidatorError = "categoriesNotEqual";

export const AssessmentValidator =
	(inputCategories: Set<string>) =>
	(control: FormControl<Assessment>): ValidationErrors => {
		if (!control.value) {
			return null;
		}

		const chosenCategories = new Set(control.value.competenceCategoryIds);

		if (!setEquals(chosenCategories, inputCategories)) {
			return {[AssessmentValidatorError]: true};
		}

		return null;
	};

function setEquals<T>(setA: Set<T>, setB: Set<T>) {
	return setA.size === setB.size && [...setA].every((x) => setB.has(x));
}
